import { environment as workforceEnvironment } from '../../environments/environment';
import { MenuItem } from './menu.item.model';

export interface AdminMenuSection {
  title: string;
  items: MenuItem[];
}

export const sections: AdminMenuSection[] = [
  ...workforceEnvironment.firebase.projectId === 'isoharja-demo'
    ? [
        {
          title: 'workforceV2.beta',
          items: [
            {icon:'people', name:'nav-item.workforce.personnel', route:'/users', exact:true},
            {
              icon: 'people-outline',
              name: 'workforceV2.requirements',
              route: '/workforce-v2/requirements',
              exact: true,
            },
            {icon:'time-outline', name:'nav-item.workforce.shifts', route:'/users/shifts', exact:true},
            {
              icon: 'people-outline',
              name: 'workforceV2.work-days',
              route: '/workforce-v2/work-days',
              exact: true,
            },
            {
              icon: 'people-outline',
              name: 'workforceV2.review',
              route: '/workforce-v2/review',
              exact: true,
            },
            {
              icon: 'people-outline',
              name: 'workforceV2.customer-approvals',
              route: '/workforce-v2/customer-approvals',
              exact: true,
            },
            {
              icon: 'people-outline',
              name: 'workforceV2.payment-milestones',
              route: '/workforce-v2/payment-milestones',
              exact: true,
            },
          ],
        },
      ]
    : [],
  {
    title: 'nav-item.home.title',
    items: [{ icon: 'home', name: 'nav-item.home.home', route: '/home' }],
  },
  {
    title: 'nav-item.operational.title',
    items: [
      {
        icon: 'business',
        name: 'nav-item.operational.sites',
        route: '/worker/sites',
      },
      {
        icon: 'briefcase-outline',
        name: 'nav-item.operational.projects',
        route: '/projects',
      },
      {
        icon: 'reader-outline',
        name: 'nav-item.operational.tasks',
        route: '/manager/tasks',
      },
    ],
  },
  {
    title: 'nav-item.business.title',
    items: [
      {
        icon: 'albums',
        name: 'nav-item.business.customers',
        route: '/clients',
      },
      {
        icon: 'cash',
        name: 'nav-item.business.additionalWork',
        route: '/contractors/sales',
      },
    ],
  },
  {
    title: 'nav-item.system.title',
    items: [
      { icon: 'cog', name: 'nav-item.system.settings', route: '/options' },
    ],
  },
  {
    title: 'nav-item.support.title',
    items: [
      {
        icon: 'help-circle-outline',
        name: 'nav-item.support.help',
        route: '/support',
      },
    ],
  },
];

export const items: MenuItem[] = sections.flatMap((section) => section.items);

export const adminMenu = {
  sections,
  items,
};
